export function formatGuideNumber(guideNumber: string | null | undefined): string | null {
    if (!guideNumber) {
        return null;
    }

    const digits = guideNumber.replace(/\D/g, '');

    if (digits.length !== 10) {
        return guideNumber;
    }

    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
}

export function guideLabel(
    guideNumber: string | null | undefined,
    fallbackId?: number | null,
): string {
    const formattedGuideNumber = formatGuideNumber(guideNumber);

    if (formattedGuideNumber) {
        return `Guía ${formattedGuideNumber}`;
    }

    return fallbackId ? `#${fallbackId}` : 'Guía no disponible';
}

export async function copyGuideNumber(guideNumber: string | null | undefined): Promise<boolean> {
    const normalizedGuideNumber = guideNumber?.replace(/\D/g, '') ?? '';

    if (normalizedGuideNumber.length !== 10) {
        return false;
    }

    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(normalizedGuideNumber);
        return true;
    }

    const input = document.createElement('textarea');
    input.value = normalizedGuideNumber;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();

    const copied = document.execCommand('copy');
    input.remove();

    return copied;
}
